import { render } from "./NewspaperSection.vue?vue&type=template&id=47b4d2bc"
import script from "./NewspaperSection.vue?vue&type=script&lang=js"
export * from "./NewspaperSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__